module.exports = ".block-text div h1{color:#fff !important}.block-text p{margin:8px 0 48px 0 !important}.infos-card{display:none}\n"